import * as React from 'react';
import shortid from 'shortid';
import { FieldDateRangeHours, DateRangeHoursSlot } from '@lib/components';

type DateSlot = T.Schema.Restaurant.Services.RestaurantServiceFeeDateSlot;

interface Props {
  dates: DateSlot[];
  onChange: (dates: DateSlot[]) => void;
}

const toDisplaySlot = (slot: DateSlot): DateRangeHoursSlot => ({
  _id: slot._id,
  fromDate: slot.fromDate || '',
  toDate: slot.toDate || slot.fromDate || '',
  open: slot.open || '09:00',
  close: slot.close || '17:00',
  h24: !!slot.h24,
});

const fromDisplaySlot = (slot: DateRangeHoursSlot): DateSlot => ({
  _id: slot._id || shortid.generate(),
  fromDate: slot.fromDate,
  toDate: slot.toDate || slot.fromDate,
  open: slot.open,
  close: slot.close,
  h24: slot.h24,
});

export const FieldFeeSpecificDates: React.FC<Props> = ({ dates, onChange }) => {
  const slots = (dates || []).map(toDisplaySlot);

  return (
    <FieldDateRangeHours
      allowNone={true}
      slots={slots}
      onChange={(next) => onChange(next.map(fromDisplaySlot))}
    />
  );
};
